import { RouterProvider } from 'react-router';
import { router } from './routes';
// import { WishlistProvider } from './context/WishlistContext';

export default function App() {
  return (
    
      <RouterProvider router={router} />
    
  );
}

